import { useState } from "react";
import { Pagination, Col, Row, Timeline } from "antd";
import { Typography } from 'antd';
import {isSelectedTab} from './../../../utils/commonFunctions'
import { SmileOutlined, UserAddOutlined, LockOutlined, ShoppingCartOutlined, CheckCircleOutlined, BellOutlined, SettingOutlined } from '@ant-design/icons';


export default function CustomerActividadComponent({selectedTab}){
  const [currentPage, setCurrentPage] = useState(1);
  const { Text, Link } = Typography;
  const itemsPerPage = 8;  

  const items = [
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <SmileOutlined /> Cliente inicia sesión          
          <br/>
          <Text type="secondary">2025-03-01 08:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'blue',
      children: (
        <>
          <UserAddOutlined /> Cliente actualiza su perfil
          <br/>
          <Text type="secondary">2025-03-02 09:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'red',
      children: (
        <>
          <LockOutlined /> Restablecimiento de contraseña solicitado
          <br/>
          <Text type="secondary">2025-03-03 10:45:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'red',
      children: (
        <>
          <LockOutlined /> Restablecimiento de contraseña exitoso
          <br/>
          <Text type="secondary">2025-03-04 11:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'yellow',
      children: (
        <>
          <ShoppingCartOutlined /> Cliente realiza compra: "Sus Dig+Exp Sin Pub Anual $799 "
          <br/>
          <Text type="secondary">2025-03-05 02:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <CheckCircleOutlined /> Compra confirmada y procesada
          <br/>
          <Text type="secondary">2025-03-05 02:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'orange',
      children: (
        <>
          <BellOutlined /> Cliente se suscribe newsletter "Wellness"
          <br/>
          <Text type="secondary">2025-03-06 04:15:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <CheckCircleOutlined /> Acceso completo al contenido plus
          <br/>
          <Text type="secondary">2025-03-06 04:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'gray',
      children: (
        <>
          <SettingOutlined /> Cliente inicia sesión
          <br/>
          <Text type="secondary">2025-03-07 08:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'gray',
      children: (
        <>
          Cliente consulta su historial de compras
          <br/>
          <Text type="secondary">2025-03-07 09:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'gray',
      children: (
        <>
          Cliente verifica la suscripción actual
          <br/>
          <Text type="secondary">2025-03-07 09:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: '#00CCFF',
      children: (
        <>
          <SettingOutlined /> Cliente personaliza su experiencia
          <br/>
          <Text type="secondary">2025-03-08 12:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'orange',
      children: (
        <>
          <BellOutlined /> Cliente recibe notificación de actualización
          <br/>
          <Text type="secondary">2025-03-09 06:30:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <CheckCircleOutlined /> Notificación leída
          <br/>
          <Text type="secondary">2025-03-09 06:45:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'red',
      children: (
        <>
          <LockOutlined /> Cliente cambia su contraseña
          <br/>
          <Text type="secondary">2025-03-10 10:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <CheckCircleOutlined /> Contraseña actualizada exitosamente
          <br/>
          <Text type="secondary">2025-03-10 10:15:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'yellow',
      children: (
        <>
          <CheckCircleOutlined /> Cliente realiza suscripción a newsletter "Opnión"
          <br/>
          <Text type="secondary">2025-03-11 03:00:00</Text> 
        </>
      ),
    },
    {
      //label: '',
      color: 'green',
      children: (
        <>
          <CheckCircleOutlined /> Compra confirmada y procesada
          <br/>
          <Text type="secondary">2025-03-11 03:30:00</Text> 
        </>
      ),
    },
  ];  

  const currentItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  
  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  return(
    <>
      <div className={isSelectedTab(selectedTab,'actividad')}>
        <div className="p-4 ">
          <Timeline 
            items={currentItems}
            //mode="left"
            
          >
            {/*
            currentItems.map((item, index) => (
              <Timeline.Item key={index} label={item.label} color={item.color}>
                {item.children} <br/> <Text type="secondary">{item.label}</Text> 
              </Timeline.Item>
            ))
            */
            }
          </Timeline>

          <Row justify="center">
            <Col>
              <Pagination
                current={currentPage}
                total={items.length}
                pageSize={itemsPerPage}
                onChange={onPageChange}
                showSizeChanger={false}
              />
            </Col>
          </Row>
        </div>
      </div>      
    </>
  )
}